import * as ActionTypes from '../ActionTypes';
const initState = {
    userProfile: "",
    usersList:"",
    users:[],
    updatedUser:'',
    userProfileForCompany:"",
    roles:[]
  };
  
  const ProfileReducer = (state = initState, action) => {
    switch (action.type) {
      
      case ActionTypes.LOADING:{
        return {
          ...state,
          userProfile: "loading...",
        };
      }
  
      case ActionTypes.LOAD_PROFILE_SUCCESS:
        return {
          ...state,
          userProfile: action.res,
          userProfileForCompany: action.res,
        };
  
      case ActionTypes.LOAD_PROFILE_ERROR:
        return {
          ...state,
          userProfile: action.res,
          userProfileForCompany: action.res,
        };
        
        case ActionTypes.LOAD_USERS_LIST_SUCCESS:
          return {
            ...state,
            usersList: action.res,
            users:action.res.data,
            roles: action.res.roles
          };
    
        case ActionTypes.LOAD_USERS_LIST_ERROR:
          return {
            ...state,
            usersList: action.res,
            roles: action.res
          };
          case ActionTypes.USER_DELETE_SUCCESS:
          return {
            ...state,
            usersList: action.res,
          };
    
        case ActionTypes.USER_DELETE_ERROR:
          return {
            ...state,
            usersList: action.res,
          };
          case ActionTypes.UPDATE_USER_SUCCESS:
          return {
            ...state,
            usersList: action.res,
            users:action.res.data,
            updatedUser: action.res.updatedUser
          };
    
        case ActionTypes.UPDATE_USER_ERROR:
          return {
            ...state,
            usersList: action.res,
          };
          case ActionTypes.FREE_USER_STATE:
          return {
            ...state,
            updatedUser: ""
          };
      case ActionTypes.CODE_ERROR:
        return {
          ...state,
          userProfile:
            "There seems to be a problem, please refresh your browser",
          userProfileForCompany: "There seems to be a problem, please refresh your browser",
        };
  
      default:
        return state;
    }
  };
  
  export default ProfileReducer;
  